import type { Message } from './message';
import { decodeMessageFromBuffer } from './message';

// Delimiter is a Uint32 (big-endian)
const DELIMITER_SIZE = 4; // bytes

function readDelimiter(dataView: DataView, offset: number) {
  // NOTE: false denotes big-endian
  return dataView.getUint32(offset, false);
}

export type Capture = Array<Message>;
export type CaptureMarker = [offset: number, messageLength: number];

function getCaptureV1Markers(buffer: ArrayBuffer) {
  const markers: Array<CaptureMarker> = [];
  const view = new DataView(buffer);
  let offset = 0;
  while (offset < buffer.byteLength) {
    const messageLength = readDelimiter(view, offset);
    offset += DELIMITER_SIZE;
    markers.push([offset, messageLength]);
    offset += messageLength;
  }
  return markers;
}

function decodeCaptureV1WithMarkers(buffer: ArrayBuffer, markers: Array<CaptureMarker>) {
  const messages: Array<Message> = [];
  for (const [offset, messageLength] of markers) {
    const slice = buffer.slice(offset, offset + messageLength);
    const message = decodeMessageFromBuffer(slice);
    if (message !== null) {
      messages.push(message);
    }
  }
  return messages;
}

function decodeCaptureV1Incremental(buffer: ArrayBuffer) {
  const view = new DataView(buffer);
  const messages: Array<Message> = [];
  let offset = 0;
  while (offset < buffer.byteLength) {
    const messageLength = readDelimiter(view, offset);
    offset += DELIMITER_SIZE;
    const slice = buffer.slice(offset, offset + messageLength);
    const message = decodeMessageFromBuffer(slice);
    if (message != null) {
      messages.push(message);
    }
    offset += messageLength;
  }
  return messages;
}

export function decodeCaptureV1(buffer: ArrayBuffer, markers?: Array<CaptureMarker>): Array<Message> {
  if (markers) return decodeCaptureV1WithMarkers(buffer, markers);
  return decodeCaptureV1Incremental(buffer);
}

export function statCaptureV1(buffer: ArrayBuffer) {
  return getCaptureV1Markers(buffer);
}
